export const labelIntersectsWithXLine = (ctx): false | "auto" => {
	const chart = ctx.chart;
	const meta = chart.getDatasetMeta(ctx.datasetIndex);
	const element = meta.data[ctx.dataIndex];

	if (!element) {
		return false;
	}

	const { y } = element.getProps(["y"], true);
	const { chartArea } = chart;
	const distanceToAxis = chartArea.bottom - y;
	const MIN_DISTANCE = 20;

	return distanceToAxis < MIN_DISTANCE ? false : "auto";
};
